<template>
  <div ref="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    excludeClasses: {
      type: Array,
      default: () => []
    }
  },
  emits: ["click-outside"],
  mounted() {
    setTimeout(() => {
      document.addEventListener("click", this.handleClickOut);
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOut);
  },
  methods: {
    handleClickOut(e) {
      const excludeClasses = this.$props.excludeClasses || [];

      const clickedInside = window.$.contains(this.$refs.container, e.target);
      const hasExcludedClass = excludeClasses.some((cls) =>
        e.target.classList?.contains(cls)
      );

      if (!clickedInside && !hasExcludedClass) this.$emit("click-outside", e);
    }
  }
};
</script>

<style lang="scss" scoped></style>
